import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { BaseFormComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { DocumentFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { UploadedFile } from "models/utilTypes/fileUtilsTypes";
//#endregion
//#region components
import UploadDocumentForm from "./uploadDocumentForm";
import { useDocumentService } from "serviceHooks";
//#endregion
import * as Yup from "yup";
import { UtilsHelper } from "utils/helpers";

const UploadDocumentFormContainer: ForwardRefRenderFunction<FormHandles, BaseFormComponentProps> = (props, ref) => {
  const documentService = useDocumentService();
  const initialValues = {
    files: [],
  } as DocumentFormTypes.UploadSharedDocument;

  const validationSchema = Yup.object<DocumentFormTypes.UploadSharedDocument>({
    files: Yup.array()
      .of(
        Yup.object<UploadedFile>({
          contentType: Yup.string(),
          fileName: Yup.string(),
          fileSize: Yup.number(),
          data: Yup.string(),
        })
      )
      .required(TranslationKeys.Validations.Required),
  });

  const handleFormSubmit = (values: DocumentFormTypes.UploadSharedDocument) => {
    if (UtilsHelper.isEmpty(values.files?.length)) {
      return Promise.resolve();
    }

    return documentService.uploadAdvisorDocuments(documentService.convertToSharedDocumentPost(values.files));
  };

  return (
    <UploadDocumentForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={initialValues}
      handleSubmit={handleFormSubmit}
    />
  );
};

export default forwardRef(UploadDocumentFormContainer);
